import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { Books, Slug, PageAction } from "@/types/models";

export const useAppStore = defineStore("app", {
  state: () => ({
    leftBarDrawer: false,
    tableOfContent: {} as Books,
    pageAction: {} as PageAction,
    slug: {} as Slug<string>,
    readMode: (localStorage.getItem("readMode") as string) || "Text View",
    isAddBookIFrameEventHandler: false,
  }),
  actions: {
    setTableOfContent(data: Books) {
      this.tableOfContent = data;
    },

    setPageAction(data: PageAction) {
      this.pageAction = data;
    },

    setSlug(data: Slug<string>) {
      this.slug = data;
    },

    updateLeftBarDrawer() {
      const router = useRouter();

      router.afterEach((to) => {
        if (to.name === "Book") {
          if (window.innerWidth >= 1280) {
            this.leftBarDrawer = true;
          } else {
            this.leftBarDrawer = false;
          }
        } else {
          this.leftBarDrawer = false;
        }
      });
    },

    toggleLeftBarDrawer() {
      this.leftBarDrawer = !this.leftBarDrawer;
    },

    setReadMode(mode: string) {
      localStorage.setItem("readMode", mode);
      this.readMode = mode;
    },

    setAddBookIFrameEventHandlerStatus(status: boolean) {
      this.isAddBookIFrameEventHandler = status;
    },
  },
});
